import { QueryFactory, SortOrder } from '@lmt/shared-types';
import { ListType } from '@lmt/unicorn-shared/app/components/calendar/PatientAndWaitingListNavigation';
import { calendarParams } from '@lmt/unicorn-shared/app/constants/calendarParams';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { useUniDispatch } from '@lmt/unicorn-shared/app/store/types';
import { useEventCallback } from '@mui/material';
import { format } from 'date-fns';
import i18next from 'i18next';

export function useOpenCalendarTab(
  modals: {
    showConfirm: (arg0: {
      title: string;
      text: string;
      okButtonText: string;
      cancelButtonText: string;
    }) => any;
  },
  props?: {
    setShownListType?: (value: ListType) => void;
  },
  tabs?: { openTab: (arg0: string) => void },
  configuration?: number,
) {
  const dispatch = useUniDispatch();
  const { data: waitingList } =
    QueryFactory.AppointmentEventsQuery.useSearchVisitsQuery({
      isWaitingList: true,
      sortBy: 'Start',
      sortOrder: SortOrder.Desc,
      limit: 1,
    });

  const openCalendarTab = useEventCallback(async (date: number | Date) => {
    const currentDate = new Date();

    if (
      !calendarParams ||
      !waitingList ||
      date < currentDate ||
      !waitingList.find((visit) => visit.start > date)
    ) {
      return;
    }
    const isConfirmed = await modals.showConfirm({
      title: i18next.t('confirmations.waiting_list_patients.title'),
      text: i18next.t('confirmations.waiting_list_patients.text'),
      okButtonText: i18next.t('confirmations.waiting_list_patients.ok_button'),
      cancelButtonText: i18next.t(
        'confirmations.waiting_list_patients.cancel_button',
      ),
    });

    if (isConfirmed) {
      if (tabs && configuration) {
        tabs.openTab(
          pages.calendar.link({
            configurationId: String(configuration),
            currentDay: format(date, 'yyyy-MM-dd'),
          }),
        );
      } else {
        props?.setShownListType?.('waitingList');
      }
    }
  });

  return openCalendarTab;
}
